import axiosHttp from "./interceptor";

export const getFailedPublishDocuments = (req) => {
    return axiosHttp.post("api/Documents/GetFailedPublishDocuments", req);
};

export const retryPublishDocument = (req) => {
    return axiosHttp.post("api/Documents/RetryPublishDocument", req);
};